<mat-sidenav-container class="sidenav-container">
    <mat-sidenav-content>
        <div [ngClass]="{'unauthenticated': authenticator.route !== 'authenticated', 'authenticated': authenticator.route == 'authenticated'}">
            <div style="padding: var(--amplify-space-large); text-align: center" *ngIf="authenticator.route !== 'authenticated'">
                <img class="amplify-image" src="assets/logo.png" style="height:150px" />
            </div>
            <amplify-authenticator [services]="services" [formFields]="formFields">
                <ng-template amplifySlot="authenticated">
                    <div fxLayout="column">
                        <mat-toolbar fxFlex="none" fxLayoutAlign="center">
                            <div class="container">
                                <div class="logo" routerLink="/home">
                                    <img src="assets/logo.png" />
                                </div>
                                <div fxFlex></div>
                                <a mat-button routerLink="/home" routerLinkActive="active" aria-label="Home">
                                    <mat-icon>home</mat-icon>
                                    Home
                                </a>
                                <a mat-button routerLink="/library" routerLinkActive="active" aria-label="Library" *ngIf="currentUser.isPresenter">
                                    <mat-icon>perm_media</mat-icon>
                                    Library
                                </a>
                                <a mat-button routerLink="/settings" routerLinkActive="active" aria-label="Settings">
                                    <mat-icon>manage_accounts</mat-icon>
                                    Settings
                                </a>
                                <a mat-button routerLink="/admin" routerLinkActive="active" aria-label="Admin" *ngIf="currentUser.isAdmin">
                                    <mat-icon>manage_accounts</mat-icon>
                                    Admin
                                </a>
                                <button type="button" mat-button aria-label="Logout" (click)="logout()">
                                    <mat-icon>logout</mat-icon>
                                    Logout
                                </button>
                            </div>
                        </mat-toolbar>
                        <div style="padding:2rem;" fxFlex fxLayoutAlign="center">
                            <div class="container">
                                <router-outlet></router-outlet>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </amplify-authenticator>
            <div style="height: 150px;" *ngIf="authenticator.route !== 'authenticated'"></div>
        </div>
    </mat-sidenav-content>
</mat-sidenav-container>